"use client"

import { transformProperties } from "@/utils/simplifyData"
import styled from "@emotion/styled"
import SwiperOnMobile from "../SwiperOnMobile/SwiperOnMobile"
import { mediaQueries } from "../theme/mediaQueries"
import CircleImageCard from "./CircleImageCard"

const StyledSwiperContainer = styled.div`
  width: 100%;
  position: relative;
  min-height: 250px;
  ${mediaQueries.desktopM} {
    min-height: auto;
    padding: 56px 0px;
  }
  ${mediaQueries.desktopXl} {
    padding: 56px 200px;
  }
`
const StyledSwiperOnMobile = styled(SwiperOnMobile)`
  ${mediaQueries.desktopM} {
    display: flex;
    > * {
      flex: 1;
    }
  }
`

interface CircleImageCardListMobileProps {
  itemsList: {
    blocks: any[]
  }
}

const CircleImageCardListSwiperMobile = ({
  itemsList,
}: CircleImageCardListMobileProps) => {
  if (!itemsList || !itemsList.blocks) return null

  return (
    <StyledSwiperContainer>
      <StyledSwiperOnMobile
        swiperProps={{
          spaceBetween: 40,
          slidesPerView: 1.25,
          centeredSlides: false,
        }}
      >
        {itemsList.blocks.map((item: any, index: number) => {
          const { title, text, image, description } = transformProperties(
            item?.properties,
          )
          return (
            <CircleImageCard
              key={`circle-image-card-list-item-${index}-${item?.title?.value}`}
              item={item}
            />
          )
        })}
      </StyledSwiperOnMobile>
    </StyledSwiperContainer>
  )
}

export default CircleImageCardListSwiperMobile
